import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import _head from 'lodash/head';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_CONTAINER_CLASS_NAME } from './PriceRange.constants';
import { createComponent } from '../../../foundation/services/components';
import { ComponentPropType } from '../../../foundation/types/component';
import { ALL_PRICE_DISPLAY_TYPE, FIRST_PRICE_DISPLAY_TYPE } from '../../constants';
import { createLabeledPriceRangeDisplay, pricesHaveLabels, getPriceRangeDisplay, createPrices, allPricesAreLabels, allPricesAreNotLabels } from '../../services/price';
import { PricePropType, PriceRangeSettingsPropType, PriceRangeSettingsPropTypeDefault } from '../../types';
import Price from '../Price';
import './PriceRange.less';
var defaultProps = {
  prices: [],
  priceLabel: '',
  multiplePricesLabel: '',
  settings: PriceRangeSettingsPropTypeDefault,
  priceKey: 'amount',
  as: 'span'
};
export default function PriceRange(_ref) {
  var prices = _ref.prices,
    priceLabel = _ref.priceLabel,
    multiplePricesLabel = _ref.multiplePricesLabel,
    settings = _ref.settings,
    priceKey = _ref.priceKey,
    as = _ref.as;
  var displayType = settings.displayType,
    labelDelimiter = settings.labelDelimiter,
    allowMixedFormats = settings.allowMixedFormats,
    hide = settings.hide;
  var finalPrices = createPrices(prices, priceKey);
  function wrapPriceRange(priceRange) {
    if (as) {
      return createComponent(as, {
        className: DEFAULT_CONTAINER_CLASS_NAME,
        children: priceRange
      });
    }
    return priceRange;
  }
  if (_isEmpty(finalPrices)) {
    return null;
  }
  if (hide) {
    return null;
  }
  if (!_isEmpty(multiplePricesLabel) && prices.length > 1) {
    return /*#__PURE__*/React.createElement(Price, _extends({
      amount: multiplePricesLabel
    }, settings));
  }
  if (!_isEmpty(priceLabel)) {
    return /*#__PURE__*/React.createElement(Price, _extends({
      amount: priceLabel
    }, settings));
  }
  if (displayType === FIRST_PRICE_DISPLAY_TYPE && allPricesAreNotLabels(finalPrices) && finalPrices.length > 1) {
    return wrapPriceRange(getPriceRangeDisplay(finalPrices, settings));
  }
  if (finalPrices.length === 1 || displayType === FIRST_PRICE_DISPLAY_TYPE) {
    var singlePrice = _head(finalPrices);
    return /*#__PURE__*/React.createElement(Price, _extends({}, singlePrice, settings));
  }
  if (allPricesAreLabels(finalPrices)) {
    if (displayType === ALL_PRICE_DISPLAY_TYPE) {
      return wrapPriceRange(createLabeledPriceRangeDisplay(finalPrices, labelDelimiter));
    }
    return wrapPriceRange('');
  }
  if (pricesHaveLabels(finalPrices)) {
    if (!allowMixedFormats) {
      return wrapPriceRange('');
    }
    return wrapPriceRange(createLabeledPriceRangeDisplay(finalPrices, labelDelimiter));
  }
  return wrapPriceRange(getPriceRangeDisplay(finalPrices, settings));
}
PriceRange.defaultProps = defaultProps;